import axios from "axios";
import { SubscriptionError, isSubscriptionErrorData } from "@/lib/api/errors";
import { sessionQueryOptions } from "@/lib/auth";
import { queryClient } from "@/lib/query-client";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3000";

let redirectingToLogin = false;

export const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error.response?.data;

    if (error.response?.status === 401) {
      if (!redirectingToLogin) {
        redirectingToLogin = true;
        queryClient.removeQueries({ queryKey: sessionQueryOptions.queryKey });
        queryClient.cancelQueries();
        window.location.href = "/";
      }
      return new Promise(() => {});
    }

    // Check for subscription errors (403 with specific codes)
    if (error.response?.status === 403 && isSubscriptionErrorData(data)) {
      return Promise.reject(new SubscriptionError(data));
    }

    const message =
      data?.error ||
      error.message ||
      `HTTP error ${error.response?.status || "unknown"}`;
    return Promise.reject(new Error(message));
  }
);
